import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

export const FpwdTitle = styled(Typography)({
  fontSize: 20,
  fontWeight: 500,
  // fontFamily: ['Inter', 'sans-serif'].join(','),
  color: '#565656',
  textAlign: 'center',
})



export const RootBox = styled(Box)({
  background: '#fff',
 
  borderRadius: '0.5rem',

})